import React from 'react';
import styled, { keyframes } from 'styled-components';
import loaderImg from '../../assets/images/logo.png';
import colors from '../../constants/colors';
export const AppLoader = () => {
  return (
    <LoaderContainer>
      <LoaderImage src={loaderImg} />
    </LoaderContainer>
  );
};

const LoaderContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.BLUE_100};
`;

const rotateslide = keyframes`   
0% { opacity: 1; transform: scale(1);} 
100% {opacity: 0.4; transform: scale(0.5);} 
`;
const LoaderImage = styled.img`
  width: 222px;
  height: 133.2px;
  animation: ${rotateslide} 2s infinite;
  animation-timing-function: ease-out;
  animation-direction: alternate;
  @media (min-width: 480px) {
    width: 148px;
    height: 88.8px;
  }
`;

export default AppLoader;
